import { render } from "./NotTestingPage.vue?vue&type=template&id=e075a980&scoped=true"
import script from "./NotTestingPage.vue?vue&type=script&lang=js"
export * from "./NotTestingPage.vue?vue&type=script&lang=js"

import "./NotTestingPage.vue?vue&type=style&index=0&id=e075a980&lang=scss&scoped=true"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e075a980"]])

export default __exports__